module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/administracion/fondeadores/reporteria/reporteria.component.scss
// module id = ./src/app/administracion/fondeadores/reporteria/reporteria.component.scss
// module chunks = main